// extracted by mini-css-extract-plugin
module.exports = {"smallIcon":"components-TaskStatusIcon-TaskStatusIcon__smallIcon--2w_D0","largeIcon":"components-TaskStatusIcon-TaskStatusIcon__largeIcon--2g5vW"};